import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { TextInput } from '@/components/form/fields/text/TextInput';
import { Loader } from '@/components/loading/Loading';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/tabs/Tabs';
import SiSearch from '@/icons/SiSearch';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { PageLoading } from '@/layouts/PageLoading';
import { Container } from '@/layouts/main/Main';
import { Approval, useApprovals } from '@/services/approvals/useApprovals';
import { useApprovalsNeeded } from '@/services/approvals/useApprovalsNeeded';
import { PageTitle } from '@/utils/Title';
import { useSearch } from '@/utils/search';

import { FunctionComponent, Suspense, useState } from 'react';

interface TabContentProps {
  data: Approval[];
}

const TabContent: FunctionComponent<TabContentProps> = ({ data }) => {
  return (
    <Suspense
      fallback={
        <div className="w-full py-8 flex justify-center items-center">
          <Loader />
        </div>
      }
    >
      {data.length > 0 ? (
        <>
          <p>TODO</p>
        </>
      ) : (
        <p className="font-semibold text-lg mt-10">No approvals needed</p>
      )}
    </Suspense>
  );
};

const ApprovalContent: FunctionComponent = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Approvals',
      to: ''
    }
  ];

  const data = useApprovals();

  const approvalsNeeded = useApprovalsNeeded();

  const [searchQuery, setSearchQuery] = useState<string>('');

  // TODO
  const filteredApprovalsByName = useSearch(data, ['name'], searchQuery);

  return (
    <>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">Approvals</h3>
        </div>
      </BreadcrumbPageHeader>
      <div className="flex-1 overflow-y-auto">
        <Container animate="pop" className="w-full py-8">
          <Tabs defaultValue={`${approvalsNeeded.length ? 'approvalNeeded' : 'approved'}`}>
            <div className="space-y-10">
              <div>
                <TabsList>
                  <TabsTrigger value="approvalNeeded">
                    Approval Needed ({approvalsNeeded.length})
                  </TabsTrigger>
                  <TabsTrigger value="approved">
                    Approved
                  </TabsTrigger>
                  <TabsTrigger value="rejected">
                    Rejected
                  </TabsTrigger>
                </TabsList>
              </div>
              <div className="space-y-3">
                <div className="flex space-x-5">
                  <TextInput
                    id="filter"
                    value={searchQuery}
                    onChange={setSearchQuery}
                    placeholder={'Search for date, product name, bundle name, etc.'}
                    prefix={<SiSearch className="text-xl" />}
                  />
                </div>
                <TabsContent value="approvalNeeded">
                  <TabContent data={filteredApprovalsByName} />
                </TabsContent>
                <TabsContent value="approved">
                  <TabContent data={filteredApprovalsByName} />
                </TabsContent>
                <TabsContent value="rejected">
                  <TabContent data={approvalsNeeded} />
                </TabsContent>
              </div>
            </div>
          </Tabs>
        </Container>
      </div>
    </>
  );
};

const ApprovalPage: FunctionComponent = () => {
  return (
    <>
      <PageTitle>Approvals</PageTitle>
      <Suspense fallback={<PageLoading />}>
        <ApprovalContent />
      </Suspense>
    </>
  );
};

export default ApprovalPage;
